import React from 'react';
import Loader from './Loader';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const LoaderCart = () => {
  const currentStep = useSelector((state: any) => state.workflow.currentStep);
  const reviewStep = currentStep.components?.find(
    (comp: any) => comp?.id === 'RXC_REVIEW_PANEL'
  );
  const [isLoaderVisible, setIsLoaderVisible] = useState(true);

  useEffect(() => {
    if (reviewStep) {
      setIsLoaderVisible(false);
    } else {
      setTimeout(() => {
        setIsLoaderVisible(false);
      }, 4500);
    }
  }, [currentStep]);

  return (
    <>
      {isLoaderVisible && (
        <div className="tw-absolute tw-top-0 tw-right-0 tw-w-100 tw-h-100 tw-bg-white tw-flex tw-items-center tw-justify-center tw-z-50">
          <Loader />
        </div>
      )}
    </>
  );
};

export default LoaderCart;
